import { Button } from "react-aria-components";
import { globalSubmittingSignal } from "../../Layout";
import { useState } from "react";
import { httpGet, httpPost } from "../../../../../modules/Backend";
import { HttpStatusCode } from 'axios';
import { toast } from "react-toastify";

interface ICancelAccountActionProps {
    data: any
}

export default function CancelAccountAction(props: ICancelAccountActionProps) {
    const { data } = props;
    const [loading, setLoading] = useState<boolean>(false);

    async function handleCancel() {
        setLoading(true);
        try {
            // First, get the list of account deletion requests to find the one for this account
            const listResponse = await httpGet("api/accountDeletionRequest/list");
            
            if (listResponse.status === HttpStatusCode.Ok) {
                const requests = listResponse.data?.accountDeletionRequests || [];
                const deletionRequest = requests.find(
                    (req: any) => req.accountId === data.id
                );

                if (deletionRequest) {
                    // Cancel the deletion request
                    const cancelResponse = await httpPost("api/accountDeletionRequest/Cancel", {
                        Id: deletionRequest.id,
                        AccountId: data.id
                    });

                    if (cancelResponse.status === HttpStatusCode.Ok) {
                        toast.success("Account deletion cancelled successfully", { position: 'top-center' });
                        window.location.reload();
                    } else {
                        toast.error(cancelResponse.data || "Failed to cancel account deletion", { position: 'top-center' });
                    }
                } else {
                    toast.error("No pending deletion request found for this account", { position: 'top-center' });
                }
            } else {
                toast.error(listResponse.data || "Failed to retrieve deletion requests", { position: 'top-center' });
            }
        } catch (error: any) {
            toast.error(error?.response?.data || "An error occurred while cancelling the deletion", { position: 'top-center' });
        } finally {
            setLoading(false);
        }
    }

    return (
        <Button 
            isDisabled={globalSubmittingSignal.value.isBusy || loading} 
            className="button button--small button--primary button--with-icon" 
            onPress={handleCancel}
        >
            <p className="button-text">{loading ? "Cancelling..." : "Cancel deletion"}</p>
        </Button>
    );
}
